import { render, staticRenderFns } from "./RmrPageHero.vue?vue&type=template&id=5c0352d0&scoped=true&"
import script from "./RmrPageHero.vue?vue&type=script&lang=js&"
export * from "./RmrPageHero.vue?vue&type=script&lang=js&"
import style0 from "./RmrPageHero.vue?vue&type=style&index=0&id=5c0352d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0352d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
